<template>
    <div>
        <form method="POST" action="" @submit.prevent="WishListAction()">
            <div class="header">
                <span class="title">
                    <span v-if="modalTitle">{{modalTitle}}</span>
                    <span v-else>Bitte tragen Sie einen Namen ein</span>
                </span>
            </div>
            <div class="content  mt-4 ">
                <div>
                    <span class="NameSpan">Name</span>
                    <input type="text" maxlength="100" style="width:100%" v-model="WLName" required />
                    <span style="color:Red;display:none;">*</span>
                </div>
                <div>
                    <span class="NameSpan">Kommentar</span>
                    <input type="text" maxlength="200" style="width:100%" v-model="WLComment">
                    <span style="color:Red;display:none;">*</span>
                </div>
            </div>
            <div class="wishlist-footer mt-4">
                <div>
                    <input type="submit" class="first-btn" value="Speichern" />
                </div>
                <div>
                    <input type="button" class="second-btn" value="Schließen" @click="modalClose()" />
                </div>
            </div>
        </form>
    </div>
</template>
<script>
    export default {
        props: ['WishListGuid', 'WishListName', 'WishListComment', 'modalName', 'modalTitle', 'wishListEan', 'Action'],
        data() {
            return {
                WLName: this.WishListName,
                WLComment: this.WishListComment
            }
        },
        methods: {
            CreateWishListAndAddItem: function () {
                var refTothis = this;
                var PortalId = getCookie("PortalId");
                var UserGuid = getCookie("UserId");
                var SearchUrl = getSearchUrl();
                var Lang = getCookie("Esperantus_Language_languageSwitcher");
                let authorizationToken = getCookie("ApiToken");
                axios({
                    method: 'Get',
                    url: SearchUrl + '/WishList/CreateWishListAndAddItem?userId=' + UserGuid + "&portalId=" + PortalId + "&wishListName=" + refTothis.WLName + '&wishListComment=' + refTothis.WLComment + '&itemEan=' + refTothis.wishListEan + '&culture=' + Lang,
                    headers: {
                        "portal-culture": getCookie("Esperantus_Language_languageSwitcher"),
                        "authorization": "Bearer " + authorizationToken,
                    }
                }).then(function (result) {
                    if (result.status === 200) {
                        var value = result.data.result;
                        if (value) {
                            refTothis.modalClose();
                        }
                    }
                });
            },
            updateWishList: function () {
                var refTothis = this;
                var PortalId = getCookie("PortalId");
                var UserGuid = getCookie("UserId");
                let authorizationToken = getCookie("ApiToken");
                var SearchUrl = getSearchUrl();
                axios({
                    method: 'Get',
                    url: SearchUrl + '/WishList/UpdateWishList?userId=' + UserGuid + "&wishListGuid=" + refTothis.WishListGuid + "&portalId=" + PortalId + "&wishListName=" + refTothis.WLName + '&wishListComment=' + refTothis.WLComment,
                    headers: {
                        "portal-culture": getCookie("Esperantus_Language_languageSwitcher"),
                        "authorization": "Bearer " + authorizationToken,
                    }
                }).then(function (result) {
                    if (result.status === 200) {
                        var value = result.data.result;
                        if (value) {
                            refTothis.Search();
                            refTothis.modalClose();
                        }
                    }
                });
            },
            WishListAction: function () {

                if (this.Action == 'CreateWishlist') {
                    this.CreateWishList();
                }
                if (this.Action == 'Create') {
                    this.CreateWishListAndAddItem();
                }
                else if (this.Action === 'Update') {
                    this.updateWishList();
                }

            },
            modalClose: function () {
                this.$root.$emit('bv::hide::modal', this.modalName);
                this.$root.$emit('bv::hide::modal', "TablewishList-modal");
            },
            Search() {
                this.$emit('Search');
            }
        },
        mounted: function () {
            if (this.WishListComment == null) {
                this.WLComment = '';
                this.WishListComment = '';
            }
        }

    }
</script>
<style>

</style>